
/*
document.addEventListener('DOMContentLoaded', function() {


    const originalTabMenu = document.querySelector('div[data-pf-type="TabsMenu"]');
    const header = document.querySelector('header.header');
    const footer = document.querySelector('footer.footer');
  
    if (!originalTabMenu || !header || !footer) return;
  
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    if (!isMobile) return;
  
    const fixedTab = document.createElement('div');
    fixedTab.className = 'fixed-tabmenu';
    fixedTab.innerHTML = `
      <button class="tab-toggle">选择分类</button>
      <div class="tab-dropdown"></div>
    `;
    document.body.appendChild(fixedTab);
  
    const tabToggle = fixedTab.querySelector('.tab-toggle');
    const tabDropdown = fixedTab.querySelector('.tab-dropdown');
    const tabButtons = originalTabMenu.querySelectorAll('button[data-pf-type="TabHeader2"]');
    const tabsData = Array.from(tabButtons).map(button => ({
      text: button.textContent.trim(),
      element: button
    }));
  
    tabsData.forEach((tab, idx) => {
      const btn = document.createElement('button');
      btn.textContent = tab.text;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
  
        tab.element.click(); //  保留原始 Tab 切换功能
  
        //  延迟两帧再滚动，确保 DOM 内容完全渲染
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToTabsMenu();
          });
        });
  
        fixedTab.style.display = 'none';
        tabDropdown.classList.remove('show');
        tabToggle.classList.remove('active');
        updateTabToggle(idx);
      });
      tabDropdown.appendChild(btn);
    });
  
    tabToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = tabDropdown.classList.toggle('show');
      tabToggle.classList.toggle('active', isExpanded);
    });
  
    function highlightActive(idx) {
      tabDropdown.querySelectorAll('button').forEach((btn, i) => {
        btn.classList.toggle('active', i === idx);
      });
    }
  
    function updateTabToggle(idx) {
      if (tabsData[idx]) {
        tabToggle.textContent = tabsData[idx].text;
        highlightActive(idx);
      }
    }
  
    function scrollToTabsMenu() {
      const headerHeight = header.offsetHeight;
      const tabsTop = originalTabMenu.getBoundingClientRect().top + window.scrollY;
      let targetScroll = tabsTop - headerHeight - 10;
      const maxScroll = document.body.scrollHeight - window.innerHeight;
      if (targetScroll > maxScroll) {
        targetScroll = maxScroll;
      }
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });
    }
  
    
    //  控制固定 Tab 显示/隐藏（避免遮挡 footer）
    function checkTabVisibility() {
      if (fixedTab.classList.contains('menu-opened')) {
        fixedTab.style.display = 'none';
        return;
      }
  
      const tabMenuRect = originalTabMenu.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const headerHeight = header.offsetHeight;
  
      fixedTab.style.top = headerHeight + 'px';
  
      if (tabMenuRect.bottom < headerHeight + 10) {
        if (footerRect.top <= window.innerHeight) {
          fixedTab.style.display = 'none';
        } else {
          fixedTab.style.display = 'block';
        }
      } else {
        fixedTab.style.display = 'none';
      }
    }
  
    let scrollTimeout;
    
    //  滚动事件节流处理，100ms 内只触发一次
    window.addEventListener('scroll', () => {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(() => {
        window.requestAnimationFrame(checkTabVisibility);
        scrollTimeout = null;
      }, 100);
    });
  
    window.addEventListener('resize', checkTabVisibility);
  
    initializeActiveTab();
  
    function initializeActiveTab() {
      const activeButton = originalTabMenu.querySelector('button[data-pf-tab-active="true"]');
      if (activeButton) {
        const activeText = activeButton.textContent.trim();
        tabToggle.textContent = activeText;
        const activeIdx = tabsData.findIndex(t => t.text === activeText);
        highlightActive(activeIdx);
      }
    }
  
    tabButtons.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        updateTabToggle(idx);
      });
    });
  
    
    //  点击非下拉区时自动关闭 dropdown
    document.addEventListener('click', function(event) {
      if (!fixedTab.contains(event.target)) {
        tabDropdown.classList.remove('show');
        tabToggle.classList.remove('active');
      }
    });
  
    //  提供全局函数以供菜单关闭后刷新可见性
    window.refreshFixedTabVisibility = checkTabVisibility;

  
});
*/

document.addEventListener('DOMContentLoaded', function () {
  // 获取原始 Tab 菜单、页面头部和底部元素
  const originalTabMenu = document.querySelector('div[data-pf-type="TabsMenu"]');
  const header = document.querySelector('header.header');
  const footer = document.querySelector('footer.footer');

  // 如果元素不存在则终止脚本
  if (!originalTabMenu || !header || !footer) return;

  // 检查是否为移动设备
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  if (!isMobile) return;

  // 创建浮动 tab 容器并添加到页面中
  const fixedTab = document.createElement('div');
  fixedTab.className = 'fixed-tabmenu pf-16';
  fixedTab.innerHTML = '<div class="tab-button-group"></div>';
  document.body.appendChild(fixedTab);

  const tabGroup = fixedTab.querySelector('.tab-button-group');
  const tabButtons = originalTabMenu.querySelectorAll('button[data-pf-type="TabHeader2"]');

  // 获取原始 tab 数据（文字、DOM 元素、class）
  const tabsData = Array.from(tabButtons).map(button => ({
    text: button.textContent.trim(),
    element: button,
    classList: [...button.classList]
  }));

  // 构建每个浮动按钮，复制样式并绑定事件
  tabsData.forEach((tab, idx) => {
    const btn = document.createElement('button');
    btn.textContent = tab.text;
    btn.setAttribute('type', 'button');
    btn.setAttribute('data-pf-type', 'TabHeader2');
    btn.setAttribute('data-pf-tab-active', 'false');
    btn.setAttribute('contenteditable', 'false');
    btn.className = tab.classList.join(' '); // 使用原样式 class

    btn.addEventListener('click', () => {
      tab.element.click(); // 激活原始 tab
    
      // 滚动到整个 TabsMenu 区块（显示原始 tab 区域）
      const tabMenuTop = originalTabMenu.getBoundingClientRect().top + window.scrollY - header.offsetHeight;
      window.scrollTo({
        top: tabMenuTop,
        behavior: 'smooth'
      });
    
      updateActiveTab(idx); // 更新浮动 tab 高亮
    });

    tabGroup.appendChild(btn);
  });

  // 设置当前激活按钮的样式状态
  function updateActiveTab(activeIdx) {
    tabGroup.querySelectorAll('button').forEach((btn, i) => {
      btn.setAttribute('data-pf-tab-active', i === activeIdx ? 'true' : 'false');
    });
  }

  // 控制浮动 tab 的显示/隐藏逻辑
  function checkTabVisibility() {
    const footerRect = footer.getBoundingClientRect();
    const tabMenuRect = originalTabMenu.getBoundingClientRect();
    const headerHeight = header.offsetHeight;
    fixedTab.style.top = headerHeight + 'px';

    if (tabMenuRect.bottom < headerHeight + 10) {
      if (footerRect.top <= window.innerHeight) {
        fixedTab.style.display = 'none';
      } else {
        fixedTab.style.display = 'flex';
      }
    } else {
      fixedTab.style.display = 'none';
    }
  }

  // 使用节流方式控制滚动事件
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) return;
    scrollTimeout = setTimeout(() => {
      window.requestAnimationFrame(checkTabVisibility);
      scrollTimeout = null;
    }, 100);
  });

  // 监听窗口大小变化
  window.addEventListener('resize', checkTabVisibility);

  // 初始化激活状态（与原页面同步）
  const activeButton = originalTabMenu.querySelector('button[data-pf-tab-active="true"]');
  if (activeButton) {
    const activeText = activeButton.textContent.trim();
    const activeIdx = tabsData.findIndex(t => t.text === activeText);
    updateActiveTab(activeIdx);
  }

  // 同步原 tab 的点击状态到浮动 tab
  tabButtons.forEach((btn, idx) => {
    btn.addEventListener('click', () => {
      updateActiveTab(idx);
    });
  });

  // 提供外部方法供 header 菜单控制调用（避免冲突）
  window.refreshFixedTabVisibility = checkTabVisibility;
});

